"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _reactZoomPanPinch = require("react-zoom-pan-pinch");
var _ModelButtonsCenter = _interopRequireDefault(require("./assets/Model-Buttons-Center.svg"));
var _ModelButtonsZoomIn = _interopRequireDefault(require("./assets/Model-Buttons-ZoomIn.svg"));
var _ModelButtonsZoomOut = _interopRequireDefault(require("./assets/Model-Buttons-ZoomOut.svg"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var limitToBounds = false;
var panningEnabled = true;
var transformEnabled = true;
var pinchEnabled = true;
var limitToWrapperBounds = false;
var disabled = false;
var dbClickEnabled = true;
var lockAxisX = false;
var lockAxisY = false;
var velocityEqualToMove = false;
var enableWheel = true;
var enableTouchPadPinch = true;
var enableVelocity = true;
var disableLimitsOnWheel = true;
var ModelPage = function ModelPage(_ref) {
  var classes = _ref.classes,
    children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactZoomPanPinch.TransformWrapper, {
    defaultScale: 1,
    options: {
      limitToBounds: limitToBounds,
      transformEnabled: transformEnabled,
      disabled: disabled
    },
    pan: {
      disabled: !panningEnabled,
      limitToWrapperBounds: limitToWrapperBounds,
      lockAxisX: lockAxisX,
      lockAxisY: lockAxisY,
      velocityEqualToMove: velocityEqualToMove,
      velocity: enableVelocity
    },
    pinch: {
      disabled: !pinchEnabled
    },
    doubleClick: {
      disabled: !dbClickEnabled
    },
    wheel: {
      wheelEnabled: enableWheel,
      touchPadEnabled: enableTouchPadPinch,
      disableLimitsOnWheel: disableLimitsOnWheel
    }
  }, function (_ref2) {
    var zoomIn = _ref2.zoomIn,
      zoomOut = _ref2.zoomOut,
      resetTransform = _ref2.resetTransform;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: classes.modelContainer
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.tools
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      onClick: zoomIn,
      className: classes.button
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _ModelButtonsZoomIn.default,
      alt: "Zoom In"
    })), /*#__PURE__*/_react.default.createElement(_core.Button, {
      onClick: zoomOut,
      className: classes.button
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _ModelButtonsZoomOut.default,
      alt: "Zoom Out"
    })), /*#__PURE__*/_react.default.createElement(_core.Button, {
      onClick: resetTransform,
      className: classes.button
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _ModelButtonsCenter.default,
      alt: "Center "
    }))), /*#__PURE__*/_react.default.createElement("div", {
      className: classes.imgSection
    }, /*#__PURE__*/_react.default.createElement(_reactZoomPanPinch.TransformComponent, null, children)));
  }));
};
var styles = function styles() {
  return {
    linkIcon: {
      width: '20px',
      verticalAlign: 'sub',
      margin: '0px 0px 0px 2px'
    },
    linkIcon2: {
      width: '20px',
      verticalAlign: 'sub',
      margin: '0px 0px 0px 0px'
    },
    link: {
      color: '#0296C9',
      fontWeight: 'bolder',
      '&:hover': {
        color: '#0296C9',
        fontWeight: 'bolder',
        textDecoration: 'none'
      }
    },
    title: {
      color: '#0B3556',
      textTransform: 'uppercase',
      fontWeight: 'bold'
    },
    button: {
      color: 'white',
      '& img': {
        width: '40px'
      }
    },
    container: {
      maxWidth: '1440px',
      margin: 'auto'
    },
    tool: {
      margin: '20px auto'
    },
    schema: {
      overflowX: 'hidden',
      overflowY: 'hidden',
      width: '100%',
      margin: 'auto'
    },
    imgSection: {
      width: '100%',
      border: '2px solid #7D92AE',
      borderRadius: '23px',
      marginBottom: '20px',
      height: 'auto',
      overflow: 'hidden',
      '& .react-transform-element': {
        display: '-webkit-box !important'
      }
    },
    img: {
      width: '100%'
    },
    modelContainer: {
      display: 'flex',
      maxWidth: '1440px',
      margin: '-67px 40px 60px 40px',
      textAlign: 'center',
      '@media (min-width: 1400px)': {
        margin: '-67px auto 60px auto'
      }
    },
    tools: {
      maxWidth: '60px',
      height: '168px',
      padding: '4px',
      marginTop: '100px',
      background: '#7D92AE',
      borderRadius: '23px 0px 0px 23px'
    }
  };
};
var _default = (0, _core.withStyles)(styles)(ModelPage);
exports.default = _default;